import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { RiAlertLine, RiAlertFill } from 'react-icons/ri';

import { certificationServiceStatus } from '../../../../constants/constants';
import { useWorkReportModals } from '../../../../context/WorkReportModalsContext';
import { Line } from '../../../../utils/globalPropTypes';
import './InspectWorkReportButton.scss';

const InspectWorkReportButton = ({
  line,
  selectedDate,
  setNewFetch,
  className,
  asignationType,
  disabled
}) => {
  const { activeInspectorExpertReviewModal } = useWorkReportModals();
  const isNoSend = line.estadoRevision.estadoCertEnum === certificationServiceStatus.noSend;
  const isWrong = line.estadoRevision.estadoCertEnum === certificationServiceStatus.wrong;
  const isReject = line.estadoRevision.estadoCertEnum === certificationServiceStatus.reject;
  const isSendReturned =
    line.estadoRevision.estadoCertEnum === certificationServiceStatus.sendReturned;
  const isRevisionExperta = line.estadoRevision.revisionExperta === true;
  const isPartialRejct = line.estadoRevision.mensaje?.includes('Rechazada parcialmente');

  const setColorIcon = () => {
    const colorSplit = line.estadoRevision.colores.split(',');

    return {
      color: colorSplit[0],
      bgColor: colorSplit[1]
    };
  };

  const fetchLines = () => {
    setNewFetch((newFetch) => !newFetch);
  };

  return (
    <>
      {line && (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={
            line.estadoRevision.mensaje ? (
              <Tooltip id="button-tooltip">{line.estadoRevision.mensaje}</Tooltip>
            ) : (
              <></>
            )
          }
          placement="top"
        >
          <button
            className={className}
            onClick={() => {
              if (
                (line.estadoRevision.editar && !disabled) ||
                (isPartialRejct && isReject && !disabled)
              ) {
                activeInspectorExpertReviewModal(
                  {
                    ...line,
                    date: selectedDate
                  },
                  fetchLines,
                  asignationType,
                  setNewFetch
                );
              }
            }}
            type="button"
          >
            {isNoSend || isWrong || (isSendReturned && isRevisionExperta) ? (
              <RiAlertFill
                color={setColorIcon().color}
                style={{
                  backgroundColor: setColorIcon().bgColor
                }}
              />
            ) : (
              <RiAlertLine
                color={setColorIcon().color}
                style={{
                  backgroundColor: setColorIcon().bgColor
                }}
              />
            )}
          </button>
        </OverlayTrigger>
      )}
    </>
  );
};

export default InspectWorkReportButton;

InspectWorkReportButton.propTypes = {
  className: PropTypes.string.isRequired,
  line: Line.isRequired,
  selectedDate: PropTypes.string,
  setNewFetch: PropTypes.func.isRequired,
  asignationType: PropTypes.number,
  disabled: PropTypes.bool.isRequired
};

InspectWorkReportButton.defaultProps = {
  selectedDate: '',
  asignationType: 0
};
